import React from "react";
import { InfoBars } from "Components/InfoBars";
import styled from "styled-components";
import { NoData } from "Components/NoData";
import { RefreshIcon } from "Components/RefreshIcon";
import { Card } from "Components/Card";
import { Spinner } from "melodies-source/Spinner";
import { useArtistEventContext } from "contexts/ArtistEventContext";
import { CardTitle } from "../Components/CardTitle";
import { useMultiDayEventContext } from "contexts/MultiDayEventContext";
import { Loader } from "../MultiDay/MetricCard/Loader";

export const Impressions: React.FC = () => {
  const eventContext = useArtistEventContext();
  const {
    multidayEvent,
    multiDayReport,
    multiDayReportLoading,
    multiDayReportError,
  } = useMultiDayEventContext();

  const impressions =
    multidayEvent && multiDayReport
      ? multiDayReport.impressions
      : eventContext.impressions;
  const impressionsLoading = multidayEvent
    ? multiDayReportLoading
    : eventContext.impressionsLoading;
  const impressionsError = multiDayReport
    ? multiDayReportError
    : eventContext.entriesError;

  const list = impressions
    ? Object.entries(impressions)
        .filter(([label]) => !!label)
        .map(([label, value]) => ({
          label,
          value,
        }))
    : [];

  return (
    <StyledCard isElevated>
      {impressionsLoading ? (
        <Loader />
      ) : (
        <>
          <CardTitle>Impressions by Section</CardTitle>
          {impressionsError ? (
            <StyledRefreshIcon />
          ) : list.length > 0 ? (
            <InfoBars data={list} impressions />
          ) : (
            <NoData />
          )}
        </>
      )}
    </StyledCard>
  );
};

const StyledRefreshIcon = styled(RefreshIcon)`
  margin-top: 5px;
`;

const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
